import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Component, OnInit } from '@angular/core';
import { filter, first } from 'rxjs/operators';
import { DataService } from '../../../service/data.service';
import { LayoutService } from '../../../service/layout.service';
import { SnackbarService } from '../../../service/snackbar.service';
import { UserService } from '../../../service/user.service';
import { MEKANIC_MENU } from '../header/menu/mekanic-menu';

@Component({
  selector: 'app-quick-access',
  templateUrl: './quick-access.component.html',
  styleUrls: ['./quick-access.component.scss']
})
export class QuickAccessComponent implements OnInit {

  quickAccess: string[] = [];
  availableMenus: string[] = [];


  constructor(
    private _layout: LayoutService,
    private _dataService: DataService,
    private _userService: UserService,
    private _snackbar: SnackbarService
  ) { }

  ngOnInit() {
    this._layout.component = 'configure';

    this._dataService.userRole$
      .pipe(
        filter(rol => !!rol),
        first()
      )
      .subscribe(role => {
        try {
          this._layout.addLoaderTrigger("QuickAccessComponent.NgOnInit.userRole$.subscribe()");

          this.availableMenus = this._getMenusToFavorite(role);
  
          if (Array.isArray(this._dataService.user.quickAccess) && this._dataService.user.quickAccess.length) {
            for (const quick of this._dataService.user.quickAccess) {
              const index = this.availableMenus.findIndex(m => m === quick);
              if (index !== -1) {
                transferArrayItem(this.availableMenus, this.quickAccess, index, this.quickAccess.length);
              }
            }
          }
        } catch (error) {
          console.error(error);
        } finally {
          this._layout.removeLoaderTrigger("QuickAccessComponent.NgOnInit.userRole$.subscribe()");
        }
      });

  }

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }
  }

  private _getMenusToFavorite(userRole: number): string[] {
    const mekanicMenus = [...MEKANIC_MENU(this._dataService.company, this._dataService.user)];
    const availableMenus: string[] = [];
    
    for (const menu of mekanicMenus) {
      if (!menu.children?.length) {
        if (!this._isMenuHiddenByBlockedRole(userRole, menu.blockedRoles ?? [])) {
          availableMenus.push(menu.component);
        }
      } else if (!this._isMenuHiddenByBlockedRole(userRole, menu.blockedRoles ?? [])) {
        for (const menuChild of menu.children) {
          if (!menuChild.children?.length) {
            if (!this._isMenuHiddenByBlockedRole(userRole, menuChild.blockedRoles ?? [])) {
              availableMenus.push(menuChild.component);
            }
          } else if (!this._isMenuHiddenByBlockedRole(userRole, menuChild.blockedRoles ?? [])) {
            for (const menuChildren of menuChild.children) {
              if (!this._isMenuHiddenByBlockedRole(userRole, menuChildren.blockedRoles ?? [])) {
                availableMenus.push(menuChildren.component);
              }
            }
          }
        }
      }
    }
    
    return availableMenus.filter(menu => !['company', 'favorites', 'configure'].includes(menu));
  }

  private _isMenuHiddenByBlockedRole(userRole: number, menuBlockedRoles: number[]): boolean {
    return menuBlockedRoles.includes(userRole);
  }
  
  onDoubleClick(currentArray: string[], targetArray: string[], currentIndex: number) {
    transferArrayItem(currentArray, targetArray, currentIndex, targetArray.length)
  }

  public async save() {
    try {
      this._layout.loader = true;
      this._dataService.user.quickAccess = this.quickAccess;
      await this._userService.update(this._dataService.user, this._dataService.company);
      this._dataService.user$.next(this._dataService.user);
      this._snackbar.success('USER.UPDATED', {name: this._dataService.user.firstName});
    } catch (error) {
      console.error(error);
      this._snackbar.error('USER.NOT_UPDATED', {name: this._dataService.user.firstName}, error);
    } finally {
      this._layout.loader = false;
    }

  }

}







